/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `pending` - Pending
 * * `active` - Active
 * * `revised` - Revised
 * * `canceled` - Canceled
 * * `terminated` - Terminated
 * * `expired` - Expired
 */
export enum PolicyStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  REVISED = 'revised',
  CANCELED = 'canceled',
  TERMINATED = 'terminated',
  EXPIRED = 'expired',
}
